import { HttpGouv } from './HttpGouv.class'
import type { HttpServiceEndpoints } from './interfaces/HttpClient.interface'

export type ExternalServicesType = {
  apiGouv: HttpServiceEndpoints
}

export class HttpExternalServices {
  public get services(): ExternalServicesType {
    return {
      apiGouv: new HttpGouv().base
    }
  }
}

export const httpExternalServices = new HttpExternalServices()
